import _toConsumableArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.assign.js";
import { MIN_SEARCH_LETTERS } from "../../../common/consts";
import { uniqueId } from "../../../common/helpers";
export function PUSH_SEARCH_QUERY(state, payload) {
  if (payload.query.query && payload.query.query.length >= MIN_SEARCH_LETTERS) {
    payload.query.id = uniqueId();
    state.queries[payload.side] = [].concat(_toConsumableArray(state.queries[payload.side]), [payload.query]);
  }
}
export function UPDATE_QUERY(state, payload) {
  var item = state.queries[payload.side].find(function (o) {
    return o.id === payload.query.id;
  });
  Object.assign(item, payload.query);
}
export function REMOVE_SINGLE_QUERY(state, payload) {
  state.queries[payload.side].splice(payload.index, 1);
}
export function CLEAR_QUERIES(state, side) {
  state.queries[side] = [];
}
export function INVOKE_SEARCH(state, sides) {
  var src = [];
  sides.forEach(function (side) {
    src.push(side + '!!!' + uniqueId());
  });
  state.invokeSearch = src;
}